/**
 * Extract the edition kind from an artwork title.
 *
 * Photographers on iconicimagesgallery.com sell the same photograph as
 * multiple tiered editions — Base, Vintage Print, Posthumous Print,
 * Co-Signed Edition, Platinum Print, Signed Limited Edition. Each tier
 * has its own price and (usually) its own DB row. The tier is encoded
 * in the title, e.g. `— Vintage Print`. This helper pulls it out so
 * the artwork card can show a subtle pill.
 *
 * Returns one of: 'vintage' | 'posthumous' | 'co-signed' | 'platinum'
 *                | 'signed' | 'framed' | null (for the default base tier).
 */
export function extractEditionKind(title = '') {
  const n = String(title).replace('—', '-').replace('–', '-').toLowerCase();
  if (/\bvintage print\b/.test(n))    return 'vintage';
  if (/\bposthumous/.test(n))         return 'posthumous';
  if (/\bco.signed/.test(n))          return 'co-signed';
  if (/\bplatinum print\b/.test(n))   return 'platinum';
  if (/\bframed print\b/.test(n))     return 'framed';
  if (/\bsigned\b/.test(n) && !/co.signed/.test(n)) return 'signed';
  return null;
}

/** Human-readable label for a badge. */
export const EDITION_LABELS = {
  vintage:    'Vintage',
  posthumous: 'Posthumous',
  'co-signed':'Co-Signed',
  platinum:   'Platinum',
  signed:     'Signed',
  framed:     'Framed',
};
